import { render, staticRenderFns } from "./CreateItemFooter.vue?vue&type=template&id=0e1aee14&scoped=true"
import script from "./CreateItemFooter.vue?vue&type=script&lang=js"
export * from "./CreateItemFooter.vue?vue&type=script&lang=js"
import style0 from "./CreateItemFooter.vue?vue&type=style&index=0&id=0e1aee14&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e1aee14",
  null
  
)

export default component.exports